/**
 * Web app client attributes sent in X-Client-Attributes header and expected in JWT payload.
 * Single source of truth for api-client, apollo-graphql, and server auth JWT checks.
 */
export const WEB_CLIENT_ATTRIBUTES = 'app-provider/gaia,app/web'

/**
 * Same as WEB_CLIENT_ATTRIBUTES as a sorted array (for JWT payload comparison).
 */
export const WEB_CLIENT_ATTRIBUTES_ARRAY = [...WEB_CLIENT_ATTRIBUTES.split(',')].sort()
